import React from 'react'
import { useEditor } from '@smartfire/js-block-engine'
import clsx from 'clsx'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { useScrollDirection } from '../../hooks/useScrollDirection'
import style from './style.module.scss'

type stickyContainerProps = React.PropsWithChildren<{
    className?: string
    offset?: number
}>

export const StickyContainer: React.FC<stickyContainerProps> = ({
    className,
    offset = 0,
    children,
}) => {
    const { isEditing } = useEditor()
    const tablet = useMediaQuery('(max-width: ' + style.tabletBreakpoint + ')')
    const scrollDir = useScrollDirection({ initialDirection: 'up', thresholdPixels: 0 })

    return (
        <div
            className={clsx(!isEditing ? style.stickyContainer : undefined, className)}
            style={
                {
                    top: tablet && scrollDir === 'down' ? 0 : undefined,
                    '--offset': `${offset}px`,
                } as React.CSSProperties
            }
        >
            {children}
        </div>
    )
}
